import { ApiResult } from "@/interfaces/api.interface";
import {
  CreateToiawaseModel,
  QueryToiawase,
  SendToiawaseKaitoModel,
  UpdateToiawaseModel,
} from "@/interfaces/toiawase.interface";
import request from "@/utils/request";
import { AxiosPromise } from "axios";

// 会社関連
export function getToiawaseList(
  params: QueryToiawase
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `toiawase/getList`,
    params,
    method: "get",
  });
}

export function getToiawase(id: string): AxiosPromise<ApiResult<any>> {
  return request({
    url: `toiawase/getById/${id}`,
    method: "get",
  });
}

export function createToiawase(
  data: CreateToiawaseModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `toiawase/create`,
    method: "post",
    data,
  });
}

export function updateToiawase(
  id: string,
  data: UpdateToiawaseModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `toiawase/update/${id}`,
    method: "patch",
    data,
  });
}

export function sendToiawaseKaito(
  id: string,
  data: SendToiawaseKaitoModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `toiawase/sendToiawaseKaito/${id}`,
    method: "patch",
    data,
  });
}
